import m from './module';
import Validation from '../model/Validation';
import {
  getProvisionalIdentifierForType,
} from '../util';

class ValidationService {
  constructor(ValidationTypeService, LogService, $q, $log, $injector) {
    "ngInject";
    this.ValidationTypeService = ValidationTypeService;
    this.LogService = LogService;
    this.$q = $q;
    this.$log = $log;
    this.$injector = $injector;
    this._validationsById = {};
  }

  create(data) {
    const promises = [];

    data = data || {};

    this.id = data.id || getProvisionalIdentifierForType('validation');
    data.target_id = data.references_events_custom_instances_id;

    promises.push(this.$q
      .when(data.validation_type)
      .then(key => {
        if (key) {
          if (key.key !== undefined) {
            // Handle case where we're sent an object instead of a string
            this.$log.warn("data.validation_type was object, expected string", data);
            key = key.key;
          }
          return this.ValidationTypeService.getByKey(key)
        } else {
          this.$log.warn("Unable to lookup ValidationType with key", key);
          return null;
        }
      })
      .then(type => {
        data.validation_type = type;
      })
      .catch(err => {
        this.$log.warn("Error retrieving validation type for validation data", data, "error:", err);
        return this.$q.reject(err);
      })
    );

    return this.$q.all(promises)
      .then(() => {
        let validation = new Validation(data);
        this._validationsById[validation.id] = validation;
        return validation;
      });
  }

  serialize(validation) {
    return {
      id: validation.id,
      validation_type: (validation.type && validation.type.key) || validation.type,
      references_events_custom_instances_id: (validation.target && validation.target.id) || validation.target_id,
      value: validation.value,
    };
  }

  updateTargetForValidation(validation) {
    return this.$q.when(validation.target_id)
      .then(target_id => {
        if (target_id) {
          return this.FieldInstanceService.getById(target_id);
        } else {
          return null;
        }
      })
      .then(targetFieldInstance => {
        validation.target = targetFieldInstance;
        return targetFieldInstance;
      })
      .catch(err => {
        this.LogService.warn("Error retrieving target field instance:", err);
      });
  }

  describeValidation(validation) {
    let description;
    if (validation.type) {
      description = validation.type.name;
      if (validation.type.value && validation.value !== null) {
        description += ': ' + validation.value;
      } else if (validation.type.target && validation.target !== null) {
        description += ': "' + validation.type.target.getLabelText() + '"';
      }
    } else {
      description = 'Unspecified Validation';
    }
    return description;
  }

  get FieldInstanceService() {
    if (!this._FieldInstanceService) {
      this._FieldInstanceService = this.$injector.get('FieldInstanceService');
    }
    return this._FieldInstanceService;
  }
}

export default ValidationService;

m.service('ValidationService', ValidationService);
